export enum ShowroomPaths {
  INDEX = '/',
  VISUAL = '/visual',
  VISUAL_BLOCK = '/visual/:block',
  VISUAL_BLOCK_FLOOR = '/visual/:block/:floor'
}
